import { useEffect } from "react";
import { AppointmentLayout } from "../components/Appointment/AppointmentLayout";
import AppointmentTable from "../components/Appointment/AppointmentTable";

export const PatientAppointmentLayout = () => {
  const patient = {
    name: "John Doe",
    phone: "+91994567890",
    email: "johndoe9876@gmail.com",
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "module";
    script.defer = true;
    script.textContent = `
      import Chatbot from "https://cdn.n8nchatui.com/v1/embed.js";
      Chatbot.init({
        n8nChatUrl: "https://periscope-tech.app.n8n.cloud/webhook/8f427031-1110-4ea3-aef7-5d06ba7d5bce/chat",
        metadata: {
          patientName: "John Doe",
          phoneNumber: "+91994567890",
          email: "johndoe9876@gmail.com",
        },
        theme: {
          button: {
            backgroundColor: "#009ef4",
            right: 20, bottom: 20, size: 50,
            iconColor: "#ffffff",
            color: "#ffffff",
            customIconSrc: "https://www.svgrepo.com/show/339963/chat-bot.svg",
            customIconSize: 60, customIconBorderRadius: 15,
            autoWindowOpen: { autoOpen: false, openDelay: 2 },
            borderRadius: "circle"
          },
          tooltip: {
            showTooltip: true,
            tooltipMessage: "Hello John",
            tooltipBackgroundColor: "#009FF5",
            tooltipTextColor: "#1c1c1c",
            tooltipFontSize: 15
          },
          chatWindow: {
            borderRadiusStyle: "rounded",
            avatarBorderRadius: 20,
            messageBorderRadius: 5,
            showTitle: true,
            title: "Vivotal Chatbot",
            titleAvatarSrc: "https://www.svgrepo.com/show/339963/chat-bot.svg",
            avatarSize: 34,
            welcomeMessage: "Hello! How can I assist you with appointments today?",
            errorMessage: "Please contact support for assistance.",
            backgroundColor: "#ffffff",
            height: 400,
            width: 400,
            fontSize: 16,
            starterPrompts: [
              "📅 Book Appointment",
              "🔁 Reschedule Appointment",
              "❌ Cancel Appointment",
              "🩺 Doctor Consultation"
            ],
            starterPromptFontSize: 12,         // Set font size
            starterPromptTextColor: "#333333", // (Optional) Set text color
            starterPromptBackgroundColor: "#f5f5f5", // (Optional) Background
            starterPromptHoverColor: "#dff2e1",       // (Optional) Hover color
            starterPrompBorderRadius: 8, // (Optional) Border radius
            renderHTML: false,
            clearChatOnReload: false,
            showScrollbar: false,
            botMessage: {
              backgroundColor: "#009ef4",
              textColor: "#fafafa",
              showAvatar: true,
              avatarSrc: "https://www.svgrepo.com/show/334455/bot.svg"
            },
            userMessage: {
              backgroundColor: "#fff6f3",
              textColor: "#050505",
              showAvatar: true,
              avatarSrc: "https://www.svgrepo.com/show/532363/user-alt-1.svg"
            },
            textInput: {
              placeholder: "Type your query",
              backgroundColor: "#ffffff",
              textColor: "#1e1e1f",
              sendButtonColor: "#f36539",
              maxChars: 50,
              maxCharsWarningMessage: "You exceeded the characters limit. Please input less than 50 characters.",
              autoFocus: false,
              borderRadius: 6,
              sendButtonBorderRadius: 50
            },
            uploadsConfig: {
              enabled: true,
              acceptFileTypes: ["jpeg", "jpg", "png", "pdf"],
              maxFiles: 5,
              maxSizeInMB: 10
            },
            voiceInputConfig: {
              enabled: true,
              maxRecordingTime: 15,
              recordingNotSupportedMessage: "To record audio, use modern browsers like Chrome or Firefox that support audio recording"
            }
          }
        }
      });
    `;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  return (
    <AppointmentLayout
      title="Appointments"
      createButtonText="+ Create Appointment"
      createButtonLink="/user-layout/doctor-list"
      upcomingLabel="Upcoming Appointments"
      pastLabel="Past Appointments"
      renderUpcomingContent={(filters) => (
        <AppointmentTable from="upcoming" currentUser={patient.name} filters={filters} />
      )}
      renderPastContent={(filters) => (
        <AppointmentTable from="past" currentUser={patient.name} filters={filters} />
      )}
    />
  );
};
